import React, { Fragment, Component } from 'react';
import { connect, batch } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse';


class MultiSelectResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: 0,
            isSelect: false,
            responseValue: 0,
            tempVal: '',
            acceptComment: null,
            values:[]
        };

        this.reviewPage = this.props.questionItemList || [];
        this.tempResponse = [];
        this.handleChange = this.handleChange.bind(this);
        this.sequenceCount = 1;
        this.isGetAllUpdate = false;
        this.isChecked = false;
    }

    componentWillReceiveProps(nextProps) {

        if (this.isGetAllUpdate !== true) {
            const { getAllItemResponse, items, multiSelectItemConfiguration, configuration, ratees, getAllItemResponseForMultiple, rateeKey, putAllForItemCollection } = nextProps;
            const { pageList, nextPageKey,dependencies } = nextProps;
            var nodeList = document.getElementsByName(`MultiSelect_${items.key}`);
            var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);

            for (const key in getAllItemResponseForMultiple) {
                this.isUpdateResponse = true;
                items.isHide = false;
                if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                    const elementRes = getAllItemResponseForMultiple[key];

                    if (rateeKey !== undefined && key === rateeKey) {
                        const { itemResponseSets } = elementRes;

                        for (const key in itemResponseSets) {
                            this.isGetAllUpdate = true;

                            if (itemResponseSets.hasOwnProperty(key)) {
                                const element = itemResponseSets[key];
                                const tempItemResponseSets = itemResponseSets[key];

                                if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                    var itemResponsesObj = element.itemResponses.length > 0 ? element.itemResponses : element.demographicResponses.length > 0 ? element.demographicResponses : []

                                    if (this.reviewPage[items.key]) {
                                    this.reviewPage[items.key][0].userResponse = itemResponsesObj;
                                    }

                                    itemResponsesObj.forEach(item => {

                                        if (item.response !== null && this.state.isSelect === false) {
                                            this.setState({
                                                isSelect: true,
                                                responseValue: item.response,
                                                // acceptComment:item.openEnd
                                            });

                                            for (const key in nodeList) {
                                                if (nodeList.hasOwnProperty(key)) {
                                                    const element = nodeList[key];

                                                    if (element.value === item.response && item.responseValue !== null && inputBoxList.length > 0) {
                                                        element.checked = true;
                                                        inputBoxList[key].value = item.openEnd;
                                                        this.handleSkipPage(item.response);
                                                        if (configuration.acceptComment !== null && item.openEnd !== null) {
                                                            inputBoxList[key].classList.add('_acceptCommentShow');
                                                        }

                                                        if (element.checked) {
                                                            this.handleDependencyRequired(element.checked, items.key, element.value);
                                                            this.handleDependencyPageSkipLogic();
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });

                                    if (tempItemResponseSets.itemResponses.length > 0) {
                                        for (const key in tempItemResponseSets.itemResponses) {
                                            if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                                const temp = tempItemResponseSets.itemResponses[key];
                                                const itemList = this.reviewPage[items.reviewPageKey];

                                                for (const key in itemList) {
                                                    if (itemList.hasOwnProperty(key)) {
                                                        const itemRes = itemList[key];

                                                        var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses : [];
                                                        this.sequenceCount = itemResponseArr.length + 1;

                                                        if ( this.state.isSelect === false) {

                                                            itemRes.userResponse.filter((el) => {
                                                                for (const key in nodeList) {
                                                                    if (nodeList.hasOwnProperty(key)) {
                                                                        const element = nodeList[key];
                                                                        if (element.checked && element.value == el.response )
                                                                        {
                                                                             itemRes.isAnswer = el.responseValue !== null ? true : false;
                                                                                if (itemRes.requiredIndicator == 2) {
                                                                                    itemRes.isRequired = el.responseValue == 1 ? false:true;
                                                                                }
                                                                        }
                                                                    }
                                                                }
                                                            })

                                                            itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;

                                                            var itemType = multiSelectItemConfiguration.itemType;
                                                            var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
                                                            processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        if (items.requiredIndicator == 2) {
                                            items.isRequired = true;
                                        } else {
                                            items.isRequired = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { responseValue } = this.state;

        if (!this.isGetAllUpdate) {
            this.handleDependencyPageSkipLogic();
            this.handleSkipPage(responseValue);
        }
    }


    handleChange = (event, configuration, rateeKey, index, type) => {
        try {
            const { items, handleItemResponse, multiSelectItemConfiguration, itemProperties, itemTempResponses, ratees, putAllForItemCollection, dependencies, nextPageKey, pageList } = this.props;
            const { responseDescription, response } = configuration;
            const { minSelections, maxSelections } = itemProperties.itemTypeProperties;

            var acceptComment = type === "input" ? event.target.value : null;
            var tempMinSelections = parseInt(minSelections) || 0;
            var tempMaxSelections = parseInt(maxSelections) || 0;

            var isMinSelection = itemProperties.itemTypeProperties.hasOwnProperty("minSelections");
            var isMaxSelection = itemProperties.itemTypeProperties.hasOwnProperty("maxSelections");

            this.setState({
                active: configuration.responseValue,
                isSelect: true,
                responseValue: configuration.responseValue,
                acceptComment: acceptComment,
            });

            var checkedCount = 0;
            var nodeList = document.getElementsByName(`MultiSelect_${items.key}`);
            var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);
            var checkboxAnswer = false;

            if ((acceptComment === null || acceptComment === "") && parseInt(configuration.acceptComment) === 2) {
                inputBoxList[index].classList.add('_acceptCommentRequired');
                this.handleCheckboxElement(true);
            } else {
                inputBoxList[index].classList.remove('_acceptCommentRequired');
                this.handleCheckboxElement(false);
            }

            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {
                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];;
                    var itemKey = itemList[key].key;
                    var _tempKey = key;

                    if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {

                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {
                                    if (isMinSelection || isMaxSelection) {

                                        for (const i in nodeList) {
                                            if (nodeList.hasOwnProperty(i)) {
                                                const element = nodeList[i];

                                                if (element.checked) {
                                                    checkedCount = checkedCount + 1;
                                                }

                                                if (nodeList[index].checked) {
                                                    if (configuration.acceptComment !== null && nodeList[index].checked) {
                                                        if (checkedCount >= tempMinSelections && tempMaxSelections < checkedCount) {
                                                            inputBoxList[index].classList.remove('_acceptCommentShow');
                                                        } else {
                                                            inputBoxList[index].classList.add('_acceptCommentShow');
                                                        }
                                                    }
                                                    this.isChecked = true;

                                                } else {
                                                    inputBoxList[index].classList.remove('_acceptCommentShow');
                                                    inputBoxList[index].classList.add('_acceptCommentHide');
                                                    this.isChecked = true
                                                }

                                                if (checkedCount >= tempMinSelections && tempMaxSelections < checkedCount) {

                                                    nodeList[index].checked = false;
                                                    itemList[key].isAnswer = true;
                                                    itemList[key].isRequired = false;

                                                    return false;
                                                } else {
                                                    const selectCount = itemList[key].userResponse.length - 1 || 0;
                                                    itemList[key].isAnswer = selectCount !== 0 ? true : false;
                                                }

                                                if (isMinSelection) {
                                                    itemList[key].isAnswer = (checkedCount >= tempMinSelections) || (tempMaxSelections <= checkedCount) ? true : false;;
                                                    itemList[key].isRequired = (checkedCount >= tempMinSelections) || (tempMaxSelections <= checkedCount) ? false : true;
                                                }

                                            }
                                        }

                                    } else if (nodeList[index].checked) {
                                        inputBoxList[index].value = null;
                                        checkedCount = checkedCount + 1;

                                        if (configuration.acceptComment !== null) {
                                            inputBoxList[index].classList.remove('_acceptCommentHide');
                                            inputBoxList[index].classList.add('_acceptCommentShow');
                                            inputBoxList[index].focus();
                                        }
                                        itemList[key].isAnswer = true;
                                        itemList[key].isRequired = false;
                                        this.isChecked = true;

                                    } else {
                                        const selectCount = itemList[key].userResponse.length - 1 || 0;
                                        itemList[key].isRequired = selectCount !== 0 ? false : true;
                                        inputBoxList[index].classList.remove('_acceptCommentShow');
                                        inputBoxList[index].classList.add('_acceptCommentHide');
                                        this.isChecked = true;
                                    }

                                        var count = nodeList.length;
                                        var value = 0;
                                        for (const key in nodeList) {
                                            if (Object.hasOwnProperty.call(nodeList, key)) {
                                                const element = nodeList[key];
                                                if (element.checked) {
                                                    value = element.value
                                                    count--;
                                                itemList[_tempKey].userResponse.filter((item) => {
                                                if (item.response === element.value) {
                                                    item.responseValue = 1;
                                                }
                                            });
                                                }
                                            }
                                        }

                                        if (count !== nodeList.length) {
                                       // itemList[key].isAnswer = true;
                                        	this.handleSkipPage(Number(value));
                                        } else {
                                            itemList[key].isAnswer = false;
                                            itemList[key].isRequired = itemList[key].requiredIndicator == 2 ? true :false;
                                        this.handleSkipPage(Number(0));
                                    }

                                    var resValue = nodeList[index].checked ? 1 : null;

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType": multiSelectItemConfiguration.itemType,
                                        "buttonGroup": null,
                                        "sequence": this.sequenceCount++,
                                        "isNa": itemList[key].isNA,
                                        "response": response,
                                        "responseValue": resValue,
                                        "openEnd": acceptComment,
                                        "responseDescription": responseDescription
                                    }];

                                    if (nodeList[index].checked === true) {


                                        if (type !== "input") {

                                            itemList[key].userResponse.filter((item) => {
                                                if (item.response === response) {
                                                    item.responseValue = resValue;
                                                }
                                            });
                                        } else {
                                            itemList[key].userResponse.filter((item) => {
                                                if (item.response === configuration.response) {
                                                    item.openEnd = acceptComment;
                                                }
                                                return true;
                                            });
                                        }
                                        this.handleSkipPage(response);
                                    } else {

                                            itemList[key].userResponse.filter((item) => {
                                                if (item.response === response) {
                                                    item.responseValue = null;
                                            }
                                        });
                                    }
                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].userResponse;
                                    var itemType = multiSelectItemConfiguration.itemType;

                                    if (itemType !== "102") {
                                        itemResponses = itemList[key].userResponse;

                                    } else {
                                        var tempList = itemList[key].userResponse;

                                        for (const key in tempList) {
                                            if (tempList.hasOwnProperty(key)) {
                                                const element = tempList[key];
                                                delete element.buttonGroup;
                                                delete element.responseValue;
                                            }
                                        }
                                        itemResponses = tempList;
                                    }

                                    if ((isMinSelection || isMaxSelection) && checkedCount >= tempMinSelections && tempMaxSelections < checkedCount) {
                                        processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                    } else {
                                        processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                    }
                                }
                            }
                        }
                        checkboxAnswer = itemList[key].isAnswer;
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                }
            }
            this.handleDependencyRequired(checkboxAnswer, items.key, response);
            this.handleDependencyPageSkipLogic();
            handleItemResponse(items.key, itemTempResponses, "itemChange", rateeKey);

        } catch (error) {
            console.log("Exception: while responding question answer in multi select response:_", error);
        }
    }

    handleDependencyPageSkipLogic = () => {
        var timeOut = setTimeout(() => {
        const { items, nextPageKey, dependencies, pageList } = this.props;

        for (const key in dependencies) {
            if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key];

                element.filter((dep) => {
                    if (dep.dependsOnKey === items.key) {
                        pageList.filter((page) => {
                            if (page.key == nextPageKey) {
                                const { items } = page;
                                page.checkOnNextButtonClick = false;

                                items.filter((itm) => {
                                    if (itm.hasDepend == true) {
                                        page.checkOnNextButtonClick = true;
                                    }
                                });
                            }
                            });
                    }
                    });
            }
        }
            clearTimeout(timeOut);
        }, 0);
    }

    handleSkipPage = (tempResponseValue) => {
        try {
            const { dependencies, items } = this.props;
            var responseValue = tempResponseValue;
            var nodeList = document.getElementsByName(`MultiSelect_${items.key}`);

            for (const key in dependencies) {
                if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key];

                    element.filter((dep) => {
                        if (dep.dependsOnKey === items.key) {

                            var skipDiv = document.getElementById("survey-item-block_" + dep.key);
                            var skipDivOld = document.getElementsByName("survey-item-block");

                            var conditionString = "";
                            element.map((item, i) => {
                                return conditionString += `( ${item.response} ${item.booleanOperator} ${tempResponseValue} ) ${item.dependsOnConditionalOperator !== null ? item.dependsOnConditionalOperator : ""}`
                            });

                            var newStr = conditionString.length > 15 ? conditionString.substr(0, conditionString.length - 1) : conditionString;
                            var result = newStr.split(') |').join(")");
                            var newCondition = result.split('|').join("||");

                            if (newCondition !== '' && eval(newCondition)) {
                                for (const key in skipDivOld) {
                                    if (Object.hasOwnProperty.call(skipDivOld, key)) {
                                        const dataId = skipDivOld[key].getAttribute('data-id');

                                        if (dataId == dep.key) {
                                            skipDivOld[key].classList.remove('_Unblock');
                                            skipDivOld[key].classList.add('_block');
                                            skipDivOld[key].classList.add(`_block_${items.key}_${responseValue}`);

                                        }
                                    }
                                }

                            } else {
                                if (this.state.isSelect) {
                                    for (const key in nodeList) {
                                        if (Object.hasOwnProperty.call(nodeList, key)) {
                                            const element = nodeList[key];
                                            var newEl = document.getElementsByClassName(`_block_${items.key}_${element.value}`)[0];

                                            if (!element.checked) {
                                                var dataId = skipDivOld[key].getAttribute('data-id');

                                                if (newEl !== undefined) {
                                                    newEl.classList.remove('_block');
                                                    newEl.classList.remove(`_block_${items.key}_${element.value}`);
                                                    newEl.classList.add('_Unblock');
                                                }
                                            } else {
                                                // this.handleDependencyRequired(dep.key, "none")
                                                // newEl.classList.add('_block');
                                                // skipDiv.style.display = "none";
                                            }
                                        }
                                    }
                                } else {
                                    skipDiv.style.display = "none";
                                }

                            }
                        }
                    })
                }
            }
        } catch (error) {
            console.log("Exceptions: while skipping item and page", error.message);
        }
    }


    handleDependencyRequired = (checkboxAnswer, itemKey, response) => {
        try {
            var test = setTimeout(() => {
            const { pageList, nextPageKey, activePageKey } = this.props;

                var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
                var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);
            
                var _blockActivePageElement = document.querySelectorAll(`._SurveyPageLevel_${activePageKey} ._block`);
                var _unBlockActiveElement = document.querySelectorAll(`._SurveyPageLevel_${activePageKey} ._Unblock`);
                for (const key in pageList) {
                    if (Object.hasOwnProperty.call(pageList, key)) {
                        if (pageList[key].key == nextPageKey) {
                            const tempItems = pageList[key].items;
                            for (const key in tempItems) {
                                if (Object.hasOwnProperty.call(tempItems, key)) {
                                    const element = tempItems[key];

                                    for (const depKey in _blockElement) {
                                        if (Object.hasOwnProperty.call(_blockElement, depKey)) {
                                            const dataId = _blockElement[depKey].getAttribute('data-id');

                                            if (element.key === dataId) {
                                                element.isHide = false;
                                            }

                                        }
                                    }

                                    for (const bKey in _unBlockElement) {
                                        if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
                                            const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

                                            if (element.key === dataIdUnblock) {
                                                element.isHide = true;
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                                if (pageList[key].key == activePageKey) {
                                    const tempItems = pageList[key].items;
                                    for (const key in tempItems) {
                                        if (Object.hasOwnProperty.call(tempItems, key)) {
                                            const element = tempItems[key];
                                            if(this.props.dependencies != undefined) {
                                                for( const depKey in this.props.dependencies) {
                                                    this.props.dependencies[depKey].map((dep) => {
                                                        if(itemKey == dep.dependsOnKey && response == dep.response && element.hasDepend == false ){
                                                            this.props.handleDynamicDependency(checkboxAnswer, dep.key, response,"samePage",element.requiredIndicator);
                                                            for (const depKey in _blockActivePageElement) {
                                                                if (Object.hasOwnProperty.call(_blockActivePageElement, depKey)) {
                                                                    const dataId = _blockActivePageElement[depKey].getAttribute('data-id');
                                                                    if (element.key === dataId) {
                                                                        element.isHide = false;
                                                                    }
                                                                }
                                                            }
                                                            for (const bKey in _unBlockActiveElement) {
                                                                if (Object.hasOwnProperty.call(_unBlockActiveElement, bKey)) {
                                                                    const dataIdUnblock = _unBlockActiveElement[bKey].getAttribute('data-id');
                                                                    if (element.key === dataIdUnblock) {
                                                                        element.isHide = true;
                                                                    }
                                                                    
                                                                }
                                                            }
                                                        } 
                                                        if(element.hasDepend && element.layoutHints == 'samepage') {
                                                            if(itemKey == dep.key){
                                                                  this.props.handleDependentItem(itemKey,dep.response,null)
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    
                                    }
                                }
                        }
                    } 
                }

                clearTimeout(test);
            }, 0);

        } catch (error) {

        }
    }

    handleCheckboxElement = (flag) => {
        try {
            const { items } = this.props;
            var nodeList = document.getElementsByName(`MultiSelect_${items.key}`);

            for (const key in nodeList) {
                if (Object.hasOwnProperty.call(nodeList, key)) {
                    const element = nodeList[key];
                }
            }
        } catch (error) {
            console.log("Exceptions: Handled the enabled and disabled checkbox in required case:_", error.message)
        }
    }

    handleRequired = (event, index) => {
        const { items, configuration } = this.props;
        var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);

        if ((this.state.acceptComment === null || this.state.acceptComment === "") && parseInt(configuration.acceptComment) === 2) {
            inputBoxList[index].classList.add('_acceptCommentRequired');
            inputBoxList[index].focus();
            this.handleCheckboxElement(true);
        } else {
            inputBoxList[index].classList.remove('_acceptCommentRequired');
            this.handleCheckboxElement(false);
        }
    }
    render() {
        const { configuration, suppressLabel, id, rateeKey, items, itemKey, className, index, horizontalAlignment } = this.props;
        const alignmentFlag = horizontalAlignment !== null ? horizontalAlignment : items.horizontalAlignment !== null ? items.horizontalAlignment:"";
        return (
            <Fragment>
                <Row>
                    <Col key={itemKey} style={{ display: "content" }} className={`_MultiSelect ${className}`}>
                        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePreSection) }}></div> : null}
                        <Col md="12">
                                <input
                                    key={configuration.key}
                                    type='checkbox'
                                    name={`MultiSelect_${items.key}`}
                                    id={`MultiSelect_${configuration.response}_${items.key}`}
                                    value={configuration.response}
                                    className={`MultiSelect_${items.key} _MultiSelectLabel`}
                                    title={configuration.responseTooltip}
                                    onChange={(event) => this.handleChange(event, configuration, rateeKey, index, "checkbox")}
                                />
                                {alignmentFlag === "right" ?
                                    <label for={`MultiSelect_${configuration.response}_${items.key}`} className={"_label-right"}>
                                        <span
                                            title={configuration.responseTooltip}
                                            className={"checkbox-label-right"}
                                            htmlFor={id}
                                            dangerouslySetInnerHTML={{ __html: configuration.responseDescription }}
                                        >
                                        </span>
                                        <span className="_CommentBoxSpan">
                                            <input
                                                className="_acceptCommentHide"
                                                name={`acceptComment_${items.key}`}
                                                value={this.state.acceptComment}
                                                onChange={(event) => this.handleChange(event, configuration, rateeKey, index, "input")}
                                                onBlur={(event) => this.handleRequired(event, index)}
                                            />
                                        </span>
                                    </label>
                                : null}
                                {alignmentFlag === "center" ?
                                    <label for={`MultiSelect_${configuration.response}_${items.key}`} className={"_label-center"}>
                                        <span
                                            title={configuration.responseTooltip}
                                            className={"checkbox-label-center"}
                                            htmlFor={id}
                                            dangerouslySetInnerHTML={{ __html: configuration.responseDescription }}
                                        >
                                        </span>
                                        <span className="_CommentBoxSpan">
                                            <input
                                                className="_acceptCommentHide"
                                                name={`acceptComment_${items.key}`}
                                                value={this.state.acceptComment}
                                                onChange={(event) => this.handleChange(event, configuration, rateeKey, index, "input")}
                                                onBlur={(event) => this.handleRequired(event, index)}
                                            />
                                        </span>
                                    </label>
                                : null}
                                {alignmentFlag === "left" ?
                                    <label for={`MultiSelect_${configuration.response}_${items.key}`} className={"_label"}>
                                        <span
                                            title={configuration.responseTooltip}
                                            className={"checkbox-label"}
                                            htmlFor={id}
                                            dangerouslySetInnerHTML={{ __html: configuration.responseDescription }}
                                        >
                                        </span>
                                        <span className="_CommentBoxSpan">
                                            <input
                                                className="_acceptCommentHide"
                                                name={`acceptComment_${items.key}`}
                                                value={this.state.acceptComment}
                                                onChange={(event) => this.handleChange(event, configuration, rateeKey, index, "input")}
                                                onBlur={(event) => this.handleRequired(event, index)}
                                            />
                                        </span>
                                    </label>
                                : null}
                        </Col>
                    </Col>
                    {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePreSection) }}></div> : null}
                </Row>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount: state.survey.answeredQuestionCount,
    getAllItemResponse: state.survey.getAllItemResponse,
    getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple
})

export default connect(mapStateToProps)(React.memo(MultiSelectResponse));
